import useLocalStorage from 'hooks/useLocalStorage';

import React from 'react';

export interface InjectedDismissableProps {
  onDismiss: () => void;
}

export const withDismissable = <P extends InjectedDismissableProps>(
  BaseComponent: React.FC<P>,
  localStorageKey: string
): React.FC<Omit<P, keyof InjectedDismissableProps>> =>
  function WidthDismissable({ ...props }) {
    const { isSaved, saveKeyInLocalStorage } = useLocalStorage(localStorageKey);

    if (isSaved) return null;

    const onDismiss = () => {
      saveKeyInLocalStorage(true);
    };

    const dismissable = <BaseComponent {...(props as P)} onDismiss={onDismiss} />;

    return dismissable;
  };

export default withDismissable;
